module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-35.b82d8008.png";